import {createContext, useContext} from 'react';
import {assert} from 'assert-ts';
import type {LockProps} from './types';

export const WorkLockContext = createContext<LockProps | undefined>(undefined);

export const useWorkLockContext = (): LockProps => {
  return assert(
    useContext(WorkLockContext),
    'WorkLockContext: context expected',
  );
};
